/* =====================================================================
   Myso Sleep - ürün detay betiği (sections/main-product.liquid)
   Varyasyon seçimi, galeri, Çok Al Çok Kazan kademeleri, ek ürünler,
   set parçaları, sabit sepete ekle çubuğu.
   ===================================================================== */
(function () {
  'use strict';

  function initPDP(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const M = window.Myso;
    const $ = (s, r = root) => r.querySelector(s);
    const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
    const sec = root.closest('.shopify-section') || document;
    const esc = M.esc, money = M.money;
    const product = JSON.parse(sec.querySelector('[data-product-json]').textContent);
    const cfg = JSON.parse(sec.querySelector('[data-pdp-config]').textContent);
    const S = cfg.strings || {};

    /* ---------- varyasyon yardımcıları ---------- */
    const defaultOnly = p => p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    const optName = (p, i) => { const o = p.options[i]; return typeof o === 'string' ? o : o.name; };
    const optValues = (p, i) => { const o = p.options[i]; return (o && o.values) ? o.values : Array.from(new Set(p.variants.map(v => v.options[i]))); };
    const find = (p, opts) => p.variants.find(v => v.options.every((o, i) => o === opts[i]));
    const firstAvail = p => p.variants.find(v => v.available) || p.variants[0];
    function fix(p, opts, pos) {
      const v = find(p, opts);
      if (v && v.available) return { v, fixed: false };
      const score = x => x.options.filter((o, i) => o === opts[i]).length;
      const c = p.variants.filter(x => x.available && (pos == null || x.options[pos] === opts[pos])).sort((a, b) => score(b) - score(a));
      if (!c.length) return { v: v || firstAvail(p), fixed: false };
      return { v: c[0], fixed: true };
    }
    const vTitle = (p, v) => defaultOnly(p) ? '' : v.options.join(' / ');
    function selects(p, v, key, skip) {
      if (defaultOnly(p)) return '';
      return p.options.map((o, i) => (skip && skip.includes(i)) ? '' : `<select class="sel" data-sel="${key}" data-pos="${i}" aria-label="${esc(optName(p, i))}">${optValues(p, i).map(val => {
        const t = v.options.slice(); t[i] = val; const tv = find(p, t); const off = !tv || !tv.available;
        return `<option value="${esc(val)}" ${val === v.options[i] ? 'selected' : ''} ${off ? 'disabled' : ''}>${esc(val)}${off ? ' (' + esc(M.strings.soldOut) + ')' : ''}</option>`;
      }).join('')}</select>`).join('');
    }

    /* ---------- durum ---------- */
    let current = product.variants.find(v => v.id === cfg.variantId) || firstAvail(product);
    const tiers = cfg.tiers || [];
    const comps = (cfg.components || []).map(c => Object.assign({}, c, { v: firstAvail(c.product) }));
    const isBundle = comps.length > 0;
    const T = {
      idx: 0,
      units: tiers.map(t => Array.from({ length: Math.max(1, t.qty || 1) }, () => current)),
      addons: tiers.map(t => t.addon ? { on: false, v: firstAvail(t.addon.product) } : null)
    };
    const BA = cfg.bundleAddon ? { on: false, v: firstAvail(cfg.bundleAddon.product) } : null;
    // setin kendi seçeneğiyle aynı adı taşıyan parça seçenekleri sete kilitlenir (ör. Beden)
    comps.forEach(c => {
      c.locked = [];
      if (defaultOnly(product) || defaultOnly(c.product)) return;
      c.product.options.forEach((o, i) => { const bi = product.options.findIndex((bo, j) => optName(product, j) === optName(c.product, i)); if (bi >= 0) c.locked.push([i, bi]); });
    });
    function syncComps() {
      comps.forEach(c => {
        if (!c.locked.length) return;
        const opts = c.v.options.slice(); let ch = false;
        c.locked.forEach(([i, bi]) => { const val = current.options[bi]; if (optValues(c.product, i).includes(val)) { opts[i] = val; ch = true; } });
        if (ch) c.v = fix(c.product, opts).v;
      });
    }

    /* ---------- fiyat hesapları ---------- */
    function tierCalc(i) {
      let pr = 0, cp = 0;
      T.units[i].forEach(v => { pr += v.price; cp += (v.compare_at_price > v.price ? v.compare_at_price : v.price); });
      const price = Math.round(pr * (1 - (tiers[i].discount || 0) / 100));
      return { price, compare: cp, saved: pr - price };
    }
    function addonCalc(a, st) {
      const v = st.v; const regular = (v.compare_at_price > v.price ? v.compare_at_price : v.price) * a.qty;
      return { price: a.price != null ? a.price : v.price * a.qty, compare: regular };
    }
    function bundleCompare() {
      if (current.compare_at_price > current.price) return current.compare_at_price;
      return comps.reduce((a, c) => a + (c.v.compare_at_price > c.v.price ? c.v.compare_at_price : c.v.price) * (c.qty || 1), 0);
    }
    function totalNow() {
      if (isBundle) { const ad = BA && BA.on ? addonCalc(cfg.bundleAddon, BA).price : 0; return { price: current.price + ad, compare: bundleCompare() }; }
      if (!tiers.length) return { price: current.price, compare: current.compare_at_price || 0 };
      const c = tierCalc(T.idx); const a = T.addons[T.idx]; const ad = a && a.on ? addonCalc(tiers[T.idx].addon, a).price : 0;
      return { price: c.price + ad, compare: c.compare };
    }

    /* ---------- çizim ---------- */
    function renderPrice() {
      const box = $('[data-price]'); if (!box) return;
      const cmp = isBundle ? bundleCompare() : (current.compare_at_price || 0);
      const pct = cmp > current.price ? Math.round((1 - current.price / cmp) * 100) : 0;
      box.innerHTML = `<b>${money(current.price)}</b>${pct ? `<s>${money(cmp)}</s><span class="save-pill">${esc((S.percentOff || '%[p]').replace('[p]', pct))}</span>` : ''}`;
    }
    function renderOptions() {
      $$('[data-opt-pos]').forEach(b => {
        const pos = +b.dataset.optPos; const val = b.dataset.value;
        const t = current.options.slice(); t[pos] = val; const tv = find(product, t);
        const on = current.options[pos] === val;
        b.classList.toggle('is-active', on); b.setAttribute('aria-checked', String(on));
        b.classList.toggle('is-off', !tv || !tv.available);
      });
      current.options.forEach((o, i) => { const l = $(`[data-opt-label="${i}"]`); if (l) l.textContent = o; });
      const sw = $('.sw.is-active'); if (sw && sw.dataset.hex) $$('.js-tint', document).forEach(el => el.style.setProperty('--tint', sw.dataset.hex));
    }
    function addonRow(a, st, key) {
      const p = a.product; const c = addonCalc(a, st);
      return `<div class="addon"><label><input type="checkbox" data-addon="${key}" ${st.on ? 'checked' : ''}> ${esc(a.label || `+${a.qty} ${p.title}`)}</label>
        ${st.on ? selects(p, st.v, 'a:' + key) : ''}
        <div class="addon__price">${money(c.price)}${c.compare > c.price ? `<s>${money(c.compare)}</s>` : ''}</div></div>`;
    }
    function renderTiers() {
      const box = $('[data-tiers]'); if (!box) return;
      if (isBundle) {
        box.innerHTML = `<div class="tier is-active has-sticker"><span class="sticker"><span>${esc(S.popular || '').replace(' ', '<br>')}</span></span>
          <div class="tier__head"><span class="radio is-on"></span><div class="tier__title">${esc(S.set)}<small>${esc(S.limited)}</small></div><div class="tier__price">${money(totalNow().price)}${bundleCompare() > current.price ? `<s>${money(bundleCompare())}</s>` : ''}</div></div>
          <div class="comps">${comps.map((c, i) => `<div class="comp">
            <a class="comp__img ${esc(c.bg)}" href="${esc(c.url)}">${c.image ? `<img src="${esc(c.image)}" alt="" loading="lazy" width="56" height="56">` : `<svg class="art" viewBox="0 0 200 150" aria-hidden="true"><use href="#a-${esc(c.art)}"/></svg>`}</a>
            <div><div class="comp__t">${(c.qty || 1) > 1 ? `${c.qty}x ` : ''}<a href="${esc(c.url)}">${esc(c.product.title)}</a>${c.free ? `<em>${esc(S.gift)}</em>` : ''}</div>
            ${defaultOnly(c.product) || c.locked.length >= c.product.options.length ? (c.locked.length ? `<div class="unit"><span class="unit__lbl">${esc(c.v.options.join(' / '))}</span></div>` : '') : `<div class="unit"><span class="unit__lbl">${c.product.options.map((o, k) => k).filter(k => !c.locked.some(l => l[0] === k)).map(k => esc(optName(c.product, k))).join(', ')}${c.locked.length ? ` · ${esc(c.locked.map(l => c.v.options[l[0]]).join(' / '))}` : ''}</span>${selects(c.product, c.v, 'c:' + i, c.locked.map(l => l[0]))}</div>`}</div></div>`).join('')}</div>
          ${cfg.bundleAddon ? addonRow(cfg.bundleAddon, BA, 'b') : ''}</div>`;
        return;
      }
      box.innerHTML = tiers.map((t, i) => {
        const c = tierCalc(i); const on = i === T.idx;
        const units = defaultOnly(product) ? '' : `<div class="tier__units"><div class="unit__lbl">${product.options.map((o, k) => esc(optName(product, k))).join(', ')}</div>${T.units[i].map((u, k) => `<div class="unit">${t.qty > 1 ? `<span class="unit__n">${k + 1}.</span>` : ''}${selects(product, u, `u:${i}:${k}`)}</div>`).join('')}</div>`;
        return `<div class="tier ${on ? 'is-active' : ''} ${t.sticker ? 'has-sticker' : ''} ${t.corner ? 'has-corner' : ''}" data-tier="${i}" role="radio" aria-checked="${on}" tabindex="0">
          ${t.corner ? `<span class="tier__corner">${esc(t.corner)}</span>` : ''}${t.sticker ? `<span class="sticker"><span>${esc(t.sticker).replace(' ', '<br>')}</span></span>` : ''}
          <div class="tier__head"><span class="radio"></span><div class="tier__title">${t.qty} ${esc(product.title)}${c.saved > 0 ? `<span class="tier__save">${esc((S.save || '[amount]').replace('[amount]', money(c.saved)))}</span>` : ''}</div><div class="tier__price">${money(c.price)}${c.compare > c.price ? `<s>${money(c.compare)}</s>` : ''}</div></div>
          ${units}${t.addon ? addonRow(t.addon, T.addons[i], i) : ''}</div>`;
      }).join('');
    }
    function renderBuy() {
      const inp = $('[data-variant-input]'); if (inp) inp.value = current.id;
      const btn = $('[data-buy]'); const lbl = $('[data-buy-label]');
      if (btn) btn.disabled = !current.available;
      if (lbl) { if (!lbl.dataset.orig) lbl.dataset.orig = lbl.textContent; lbl.textContent = current.available ? lbl.dataset.orig : M.strings.soldOut; }
      const tot = totalNow();
      const sp = $('[data-satc-price]', document); if (sp) sp.innerHTML = `<b>${money(tot.price)}</b>${tot.compare > tot.price ? `<s>${money(tot.compare)}</s>` : ''}`;
      const sv = $('[data-satc-variant]', document);
      if (sv) sv.textContent = isBundle ? `${S.set} · ${S.limited}` : [tiers.length ? `${tiers[T.idx].qty} ${S.units}` : '', vTitle(product, current)].filter(Boolean).join(' · ');
      const sb = $('[data-satc-buy]', document); if (sb) sb.disabled = !current.available;
    }
    function refresh() { renderPrice(); renderOptions(); renderTiers(); renderBuy(); }

    /* ---------- galeri ---------- */
    let slide = Math.max(0, $$('.slide').findIndex(s => s.classList.contains('is-active')));
    function go(i) {
      const n = $$('.slide').length; if (!n) return; slide = (i + n) % n;
      $$('.slide').forEach((s, k) => s.classList.toggle('is-active', k === slide));
      $$('.thumb').forEach((s, k) => s.classList.toggle('is-active', k === slide));
      $$('.slide video').forEach(v => { if (!v.closest('.is-active')) v.pause(); });
    }
    function goMedia(id) { const i = $$('.slide').findIndex(s => s.dataset.mediaId == id); if (i >= 0) go(i); }

    /* ---------- varyasyon ayarla ---------- */
    function setVariant(v, announce) {
      current = v;
      T.units = T.units.map(arr => arr.map(() => v));
      syncComps();
      if (v.featured_media && v.featured_media.id) goMedia(v.featured_media.id);
      if (!isBundle || !defaultOnly(product)) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString());
      }
      refresh();
      if (announce) M.toast(announce);
    }

    /* ---------- olaylar ---------- */
    root.addEventListener('click', e => {
      const g = e.target.closest('[data-gal]'); if (g) { go(slide + (+g.dataset.gal)); return; }
      const th = e.target.closest('[data-thumb]'); if (th) { go(+th.dataset.thumb); return; }
      const ob = e.target.closest('[data-opt-pos]');
      if (ob) {
        const pos = +ob.dataset.optPos; const opts = current.options.slice(); opts[pos] = ob.dataset.value;
        const r = fix(product, opts, pos);
        const msg = r.fixed ? (M.strings.autoFixed || '').replace('[value]', ob.dataset.value).replace('[variant]', r.v.options.join(' / ')) : '';
        setVariant(r.v, msg); return;
      }
      const ms = e.target.closest('[data-modal-src]');
      if (ms) { const tpl = document.querySelector(ms.dataset.modalSrc); if (tpl) M.modal(ms.dataset.modalTitle || '', tpl.innerHTML); return; }
      const tr = e.target.closest('[data-tier]');
      if (tr && !e.target.closest('select, input, label, a')) { const i = +tr.dataset.tier; if (i !== T.idx) { T.idx = i; renderTiers(); renderBuy(); } }
    });
    root.addEventListener('keydown', e => {
      const tr = e.target.closest('[data-tier]');
      if (tr && (e.key === 'Enter' || e.key === ' ') && e.target === tr) { e.preventDefault(); T.idx = +tr.dataset.tier; renderTiers(); renderBuy(); const n = $(`[data-tier="${T.idx}"]`); n && n.focus(); }
      if (e.target.matches('[data-gallery]') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) go(slide + (e.key === 'ArrowRight' ? 1 : -1));
    });
    root.addEventListener('change', e => {
      const el = e.target;
      if (el.dataset.sel) {
        const key = el.dataset.sel; const pos = +el.dataset.pos;
        const parts = key.split(':');
        const baseV = parts[0] === 'u' ? T.units[parts[1]][parts[2]] : parts[0] === 'c' ? comps[+parts[1]].v : (parts[1] === 'b' ? BA : T.addons[+parts[1]]).v;
        const opts = baseV.options.slice();
        $$(`select[data-sel="${key}"]`).forEach(sl => { opts[+sl.dataset.pos] = sl.value; });
        if (parts[0] === 'u') { const [, i, k] = parts; T.units[i][k] = fix(product, opts, pos).v; if (+i !== T.idx) T.idx = +i; }
        else if (parts[0] === 'c') { const c = comps[+parts[1]]; c.v = fix(c.product, opts, pos).v; }
        else if (parts[0] === 'a') {
          const k = parts[1]; const st = k === 'b' ? BA : T.addons[+k]; const a = k === 'b' ? cfg.bundleAddon : tiers[+k].addon;
          st.v = fix(a.product, opts, pos).v;
        }
        renderTiers(); renderBuy(); return;
      }
      if (el.dataset.addon != null) {
        const k = el.dataset.addon; const st = k === 'b' ? BA : T.addons[+k]; st.on = el.checked;
        if (k !== 'b') T.idx = +k; renderTiers(); renderBuy();
      }
    });
    const gal = $('[data-gallery]');
    if (gal) {
      let sx = null;
      gal.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') sx = e.clientX; });
      gal.addEventListener('pointerup', e => { if (sx != null && Math.abs(e.clientX - sx) > 40) go(slide + (e.clientX < sx ? 1 : -1)); sx = null; });
    }

    /* ---------- sepete ekle ---------- */
    function items() {
      const out = [];
      if (isBundle) {
        const props = {};
        comps.forEach(c => { const k = `${(c.qty || 1) > 1 ? c.qty + 'x ' : ''}${c.product.title}${c.free ? ' (' + S.gift + ')' : ''}`; props[k] = vTitle(c.product, c.v) || '✓'; });
        out.push({ id: current.id, quantity: 1, properties: props });
        if (BA && BA.on) out.push({ id: BA.v.id, quantity: cfg.bundleAddon.qty || 1, properties: { [S.addonProp]: product.title } });
        return out;
      }
      if (!tiers.length) return [{ id: current.id, quantity: 1 }];
      const t = tiers[T.idx]; const group = new Map();
      T.units[T.idx].forEach(v => group.set(v.id, (group.get(v.id) || 0) + 1));
      group.forEach((q, id) => out.push(t.discount ? { id, quantity: q, properties: { [S.pack]: `${t.qty} ${S.units}` } } : { id, quantity: q }));
      const a = T.addons[T.idx];
      if (a && a.on) out.push({ id: a.v.id, quantity: t.addon.qty || 1, properties: { [S.addonProp]: product.title } });
      return out;
    }
    async function buy(e) {
      e && e.preventDefault();
      const btn = $('[data-buy]'); btn && btn.classList.add('is-loading');
      try { await M.cart.add(items()); }
      catch (err) { M.toast(err.message); }
      finally { btn && btn.classList.remove('is-loading'); }
    }
    const form = $('form[data-type="add-to-cart-form"]'); form && form.addEventListener('submit', buy);
    const sb = document.querySelector('[data-satc-buy]'); sb && sb.addEventListener('click', buy);

    /* ---------- sabit çubuk ---------- */
    const satc = document.querySelector('[data-satc]'); const anchor = $('[data-buy]');
    if (satc && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; satc.classList.toggle('is-on', on); satc.setAttribute('aria-hidden', String(!on)); }).observe(anchor);
    }

    syncComps();
    refresh();
  }

  function boot() { document.querySelectorAll('[data-pdp]').forEach(initPDP); }
  if (window.Myso && window.Myso.cart) boot(); else document.addEventListener('myso:ready', boot);
  document.addEventListener('shopify:section:load', boot);
})();
